export const INPUT_METHODS = {
  KEYBOARD: 'keyboard',
  MOUSE: 'Mouse click',
  REMOTE_CONTROL: 'Remote control',
}
